/**
 * Shared file helpers (name/extension parsing).
 *
 * NOTE: some extension/size parsing is still duplicated elsewhere
 * (`pages/KPI/utils.ts` `convertFileSize`, `services/queries/SoiAgentQueries.ts`
 * ad-hoc `split('.').pop()`); consolidate those here in a follow-up.
 */

/** Lower-cased extension (without the dot), or '' if the name has no extension. */
export function getFileExtension(fileName: string): string {
  const lastDot = fileName.lastIndexOf('.');
  if (lastDot < 0 || lastDot === fileName.length - 1) {
    return '';
  }
  return fileName.slice(lastDot + 1).toLowerCase();
}

/** True when a file name has a `.zip` extension. */
export function isZipFileName(name: string): boolean {
  return getFileExtension(name) === 'zip';
}

/** True when a file has a `.zip` extension. */
export function isZipFile(file: File): boolean {
  return isZipFileName(file.name);
}
